import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';

import { environment } from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.auth.authority,
    redirectUrl: environment.auth.redirectUri,
    postLogoutRedirectUri: environment.auth.postLogoutRedirectUri,
    unauthorizedRoute: '/forbidden',
    forbiddenRoute: '/forbidden',
    clientId: environment.auth.clientId,
    scope: environment.auth.scope,
    responseType: 'code',
    ignoreNonceAfterRefresh: true,
    allowUnsafeReuseRefreshToken: false,
    disableRefreshIdTokenAuthTimeValidation: true,
    silentRenew: true,
    useRefreshToken: true,
    autoUserInfo: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    renewUserInfoAfterTokenRenew: true,
    triggerAuthorizationResultEvent: true,
    secureRoutes: environment.auth.secureRoutes,
    logLevel: environment.production ? LogLevel.Error : LogLevel.Debug,
  },
};
